import { NavLink } from "react-router-dom";
import { clsx as cx } from "clsx";

import { MenuItem } from "../types";

import styles from "./navItem.module.scss";
import { NavItemHeader } from "./NavItemHeader";

type NavItemProps = {
  item: MenuItem;
};

export const NavItem = (props: NavItemProps) => {
  const { label, to, children, icon } = props.item;

  if (children && children.length === 0) {
    return null;
  }

  if (children) {
    return <NavItemHeader item={props.item} />;
  }

  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        cx(styles.navItem, { [styles.activeNavItem]: isActive })
      }
    >
      <i className={`pi ${icon} ${styles.icon}`}></i>
      <span className={styles.navLabel}>{label}</span>
    </NavLink>
  );
};
